export { BannerText } from './BannerText';
